// extracted by mini-css-extract-plugin
export default {"submenu":"Dropdown_submenu__-ybJc","submenuClicked":"Dropdown_submenuClicked__obo+e","cMenu":"Dropdown_cMenu__EK-LS"};